import { render, staticRenderFns } from "./deliverUser.vue?vue&type=template&id=c9355b10&scoped=true"
import script from "./deliverUser.vue?vue&type=script&lang=js"
export * from "./deliverUser.vue?vue&type=script&lang=js"
import style0 from "./deliverUser.vue?vue&type=style&index=0&id=c9355b10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9355b10",
  null
  
)

export default component.exports